import ApiService from './api.service'

const MonitoringService = {
	getExtraCostByDeps(depId) {
		return ApiService.get(`/extra-cost/list-by-department/${depId}`);
	},
	getExtraCostByDocument(documentId) {
		return ApiService.get(`/extra-cost/list-by-document/${documentId}`);
	}
};

export default MonitoringService;
